import { MinusCircle } from '@phosphor-icons/react';

export default MinusCircle;
